import React, { Component } from "react";
import { Translate } from "react-localize-redux";
import "./style.css";

export default class Footer extends Component {
    render() {
        return (
            <Translate>
                {({ translate }) => (
                    <div className="con-footer">
                        <div>Copyrights © 2021 tamidi</div>
                        <div>All Rights Reserved by Bao Tin Hoang Gia</div>
                    </div>
                )}
            </Translate>
        );
    }
}



// WEBPACK FOOTER //
// ./src/04-containers/Footer/index.js